module.exports = __webpack_public_path__ + "static/media/2025-AFL-Origin-Guernsey-Giveaway-Logged-In.25fdd37b.jpg";